module.exports = __webpack_public_path__ + "img/logo.c8393c4a.png";